/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const ArrowSwooshUpRightIcon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 16, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="ArrowSwooshUpRightIcon"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            d="M9 3.70711L5.85355 6.85355L5.14645 6.14645L9.5 1.79289L13.8536 6.14645L13.1464 6.85355L10 3.70711L10 8.5C10 10.9853 7.98528 13 5.5 13H4V12H5.5C7.433 12 9 10.433 9 8.5L9 3.70711Z"
            fill="currentColor"
          />
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

ArrowSwooshUpRightIcon.tags = [
  'upward',
  'direction',
  'swoosh',
  'curved',
  'move',
];

ArrowSwooshUpRightIcon.category = 'Arrows';

ArrowSwooshUpRightIcon.iconSize = 16;
